import moment from 'moment'
export const month = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

export const dateFormat = (value, hours = true) => {
  if (!value) return value
  const [year, month, day] = value.split('T')[0].split('-')
  const temporalDate = new Date(value)
  let hour = temporalDate.getHours().toString().padStart(2, '0')
  let minutes = temporalDate.getMinutes().toString().padStart(2, '0')
  if (hours) {
    return `${day}/${month}/${year} - ${hour}:${minutes}`
  }
  return `${day}/${month}/${year}`
}

export const timeFormat = (value, ifSeconds = true) => {
  if (!value) return value
  const temporalTime = new Date(value)
  let hour = temporalTime.getHours().toString().padStart(2, '0')
  let minutes = temporalTime.getMinutes().toString().padStart(2, '0')
  if (!ifSeconds) return `${hour}:${minutes}`
  let seconds = temporalTime.getSeconds().toString().padStart(2, '0')
  return `${hour}:${minutes}:${seconds}`
}

export const formatDatePicker = (value) => {
  if (!value || !moment(value).isValid()) return ''
  let dateTemp = value
  if (dateTemp.includes('T')) dateTemp = dateTemp.split('T')[0]
  return moment(dateTemp).format('YYYY-MM-DD')
}

export const formatDate = (date, time = false) => {
  if (!date || !moment(date).isValid()) return ''
  if (time) return moment(date).format('DD-MMM-YYYY h:mm a')
  else {
    let dateTemp = date
    if (typeof dateTemp === 'string' && dateTemp.includes('T')) {
      dateTemp = dateTemp.split('T')[0]
    }
    return moment(dateTemp).format('DD-MMM-YYYY')
  }
}

export const parseTime = (value) => {
  if (!value) return value
  let time = new Date()
  const [hour, minutes] = value.split(':')
  time.setHours(hour, minutes)
  return time
}

export const getWtzDate = (match, format, setTime) => {
  let { date, time, wtz } = match
  let dateFormat = moment('1970-01-01')
  if (date && moment(date.split('T')[0]).isValid()) {
    dateFormat = moment(date.split('T')[0])
    dateFormat.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
  }

  if (time && moment(time, 'HH:mm').isValid()) {
    dateFormat.set({ hour: time.split(':')[0], minute: time.split(':')[1] })
  }

  if (wtz && !Number.isNaN(wtz)) {
    const wtzTemp = Number(wtz)
    const offset = new Date().getTimezoneOffset() / -60
    if (offset > wtzTemp) dateFormat = dateFormat.add(offset - wtzTemp, 'hours')
    else dateFormat = dateFormat.subtract(wtzTemp - offset, 'hours')
  }

  return format ? formatDate(dateFormat, setTime) : dateFormat
}
